module.exports = __webpack_public_path__ + "img/logo_genl.1b298af4.png";